const ModalActionTypes = {
  TOGGLE_MODAL_VISIBLE: "TOGGLE_MODAL_VISIBLE",
  SET_MODAL_CONTEXT: "SET_MODAL_CONTEXT"
};
export default ModalActionTypes;
